module.exports = __webpack_public_path__ + "img/trophy7.jpg";